export default __webpack_public_path__ + "static/media/BinarySearchImg.9e3d8fd8.jpg";